const clearMsalStorage = (storage) => {
  if (!storage) {
    return 0;
  }

  const keys = [];
  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);
    if (key && key.toLowerCase().includes("msal")) {
      keys.push(key);
    }
  }

  keys.forEach((key) => storage.removeItem(key));
  return keys.length;
};

export const resetAuthSession = async (instance) => {
  const confirmed = window.confirm(
    "This will clear your Microsoft sign-in session for Tools and reload the page. Continue?"
  );

  if (!confirmed) {
    return;
  }

  try {
    const account = instance?.getActiveAccount?.() || instance?.getAllAccounts?.()?.[0] || null;

    if (account && instance?.logoutRedirect) {
      await instance.logoutRedirect({ account, postLogoutRedirectUri: "/" });
      return;
    }
  } catch (logoutError) {
    console.warn("MSAL logout redirect failed; clearing local auth state", logoutError);
  }

  clearMsalStorage(window.localStorage);
  clearMsalStorage(window.sessionStorage);
  window.location.reload();
};
